import React from 'react'

export default function Faq() {
	return (
		<section
			id="faq"
			className="elementor-section elementor-top-section elementor-element elementor-element-584fec3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
			data-id="584fec3"
			data-element_type="section"
			data-settings='{"background_background":"classic"}'>
			<div className="elementor-container elementor-column-gap-default">
				<div className="container-main w-container">
					<div
						className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f10ddb5"
						data-id="f10ddb5"
						data-element_type="column">
						<div className="elementor-widget-wrap elementor-element-populated">
							<div
								className="elementor-element elementor-element-9088f27 elementor-widget elementor-widget-menu-anchor"
								data-id="9088f27"
								data-element_type="widget"
								data-widget_type="menu-anchor.default">
								<div className="elementor-widget-container">
									<div id="FAQs" className="elementor-menu-anchor" />
								</div>
							</div>
							<div
								className="elementor-element elementor-element-71fd3a2 elementor-widget elementor-widget-heading"
								data-id="71fd3a2"
								data-element_type="widget"
								data-widget_type="heading.default">
								<div className="elementor-widget-container">
									<h4 className="elementor-heading-title elementor-size-default">
										FAQ's
									</h4>
								</div>
							</div>
							<div
								className="elementor-element elementor-element-b5bb10a elementor-widget elementor-widget-toggle"
								data-id="b5bb10a"
								data-element_type="widget"
								data-widget_type="toggle.default">
								<div className="elementor-widget-container">
									<style
										dangerouslySetInnerHTML={{
											__html:
												'\n                                    /*! elementor - v3.5.6 - 28-02-2022 */\n\n                                    .elementor-toggle {\n                                        text-align: left\n                                    }\n\n                                    .elementor-toggle .elementor-tab-title {\n                                        font-weight: 700;\n                                        line-height: 1;\n                                        margin: 0;\n                                        padding: 15px;\n                                        border-bottom: 1px solid #d4d4d4;\n                                        cursor: pointer;\n                                        outline: none\n                                    }\n\n                                    .elementor-toggle .elementor-tab-title .elementor-toggle-icon {\n                                        display: inline-block;\n                                        width: 1em\n                                    }\n\n                                    .elementor-toggle .elementor-tab-title .elementor-toggle-icon svg {\n                                        -webkit-margin-start: -5px;\n                                        margin-inline-start: -5px;\n                                        width: 1em;\n                                        height: 1em\n                                    }\n\n                                    .elementor-toggle .elementor-tab-title .elementor-toggle-icon.elementor-toggle-icon-right {\n                                        float: right;\n                                        text-align: right\n                                    }\n\n                                    .elementor-toggle .elementor-tab-title .elementor-toggle-icon.elementor-toggle-icon-left {\n                                        float: left;\n                                        text-align: left\n                                    }\n\n                                    .elementor-toggle .elementor-tab-title .elementor-toggle-icon .elementor-toggle-icon-closed {\n                                        display: block\n                                    }\n\n                                    .elementor-toggle .elementor-tab-title .elementor-toggle-icon .elementor-toggle-icon-opened {\n                                        display: none\n                                    }\n\n                                    .elementor-toggle .elementor-tab-title.elementor-active {\n                                        border-bottom: none\n                                    }\n\n                                    .elementor-toggle .elementor-tab-title.elementor-active .elementor-toggle-icon-closed {\n                                        display: none\n                                    }\n\n                                    .elementor-toggle .elementor-tab-title.elementor-active .elementor-toggle-icon-opened {\n                                        display: block\n                                    }\n\n                                    .elementor-toggle .elementor-tab-content {\n                                        padding: 15px;\n                                        border-bottom: 1px solid #d4d4d4;\n                                        display: none\n                                    }\n\n                                    @media (max-width:767px) {\n                                        .elementor-toggle .elementor-tab-title {\n                                            padding: 12px\n                                        }\n\n                                        .elementor-toggle .elementor-tab-content {\n                                            padding: 12px 10px\n                                        }\n                                    }\n                                ',
										}}
									/>
									<div className="elementor-toggle" role="tablist">
										<div className="elementor-toggle-item">
											<div
												id="elementor-tab-title-1901"
												className="elementor-tab-title"
												data-tab={1}
												role="tab"
												aria-controls="elementor-tab-content-1901"
												aria-expanded="false">
												<span
													className="elementor-toggle-icon elementor-toggle-icon-right"
													aria-hidden="true">
													<span className="elementor-toggle-icon-closed">
														<i className="fas fa-plus" />
													</span>
													<span className="elementor-toggle-icon-opened">
														<i className="elementor-toggle-icon-opened fas fa-plus" />
													</span>
												</span>
												<a className="elementor-toggle-title">
													DO YOU HAVE A ROADMAP?
												</a>
											</div>
											<div
												id="elementor-tab-content-1901"
												className="elementor-tab-content elementor-clearfix"
												data-tab={1}
												role="tabpanel"
												aria-labelledby="elementor-tab-title-1901">
												<p>
													Our roadmap shows a complete path how the Metamates
													Ape Lounge will start and enter the metaverse world,
													celebration sale events, partnering with major brand
													vendors for our holders, Continuous projects,
													supporting a huge cause. We believe in less talk and
													more action. Our Team is always been creative and
													hardworking on great plans &amp; ideas, adding more
													value &amp; increasing store value to our holders.
													More to come!
												</p>
											</div>
										</div>
										<div className="elementor-toggle-item">
											<div
												id="elementor-tab-title-1902"
												className="elementor-tab-title"
												data-tab={2}
												role="tab"
												aria-controls="elementor-tab-content-1902"
												aria-expanded="false">
												<span
													className="elementor-toggle-icon elementor-toggle-icon-right"
													aria-hidden="true">
													<span className="elementor-toggle-icon-closed">
														<i className="fas fa-plus" />
													</span>
													<span className="elementor-toggle-icon-opened">
														<i className="elementor-toggle-icon-opened fas fa-plus" />
													</span>
												</span>
												<a className="elementor-toggle-title">
													When Will MetaMates Ape Lounge Launch?
												</a>
											</div>
											<div
												id="elementor-tab-content-1902"
												className="elementor-tab-content elementor-clearfix"
												data-tab={2}
												role="tabpanel"
												aria-labelledby="elementor-tab-title-1902">
												<p>
													We are trying to wrap all our postproduction work to
													make sure all audiences and buyers will get the best
													experiences of Metamates collectibles. Ape minting
													process will be announced shortly on our discord
													/twitter/Mining page. Stay active and ensure you have
													our notifications enabled on our official Twitter to
													make sure you don&apos;t miss a beat!
												</p>
											</div>
										</div>
										<div className="elementor-toggle-item">
											<div
												id="elementor-tab-title-1903"
												className="elementor-tab-title"
												data-tab={3}
												role="tab"
												aria-controls="elementor-tab-content-1903"
												aria-expanded="false">
												<span
													className="elementor-toggle-icon elementor-toggle-icon-right"
													aria-hidden="true">
													<span className="elementor-toggle-icon-closed">
														<i className="fas fa-plus" />
													</span>
													<span className="elementor-toggle-icon-opened">
														<i className="elementor-toggle-icon-opened fas fa-plus" />
													</span>
												</span>
												<a className="elementor-toggle-title">
													Mint amount &amp; price?
												</a>
											</div>
											<div
												id="elementor-tab-content-1903"
												className="elementor-tab-content elementor-clearfix"
												data-tab={3}
												role="tabpanel"
												aria-labelledby="elementor-tab-title-1903">
												<p>
													We wanted to be fully transparent to our Holders who
													will participate our auction house. <br />
													<br /> Pre sale1 (ETH): The price to mint auction will
													start a character from the Meta Mates Ape Lounge World
													at 0.05 ETH with 1000 unique opportunities. <br /> Pre
													sale1 (SOL) : The price to mint auction will start a
													character from the Meta Mates Ape Lounge World at 2
													SOL with 1000 unique opportunities. <br />
													<br /> **Don’t worry we would give you an second
													opportunity if you missed sale 1** <br />
													<br></br>
													Pre sale2 (ETH): The price to mint auction will start
													a character from the Meta Mates Ape Lounge World at
													0.5 ETH with 1000 unique opportunities. <br /> Pre
													sale2 (SOL): The price to mint auction will start a
													character from the Meta Mates Ape Lounge World at 9
													SOL with 1000 unique opportunities. <br />
													<br />
													** Better late than never, there is a bigger chance
													now to set your footprint into Metamates Ape Lounge
													World, Go Grab it now on final sale! **
													<br /> <br /> ** FULL SALE GRAB (ETH) : The price to
													mint auction will start a character from the Meta
													Mates Ape Lounge World at 1 ETH with 1000 unique
													opportunities. <br />
													GRAB ( SOL) : The price to mint auction will start a
													character from the Meta Mates Ape Lounge World at 20
													SOL with 1000 unique opportunities. <br /> <br />
													**There is a 1% royalty on your holdings of which 50%
													of the royalty will donated to Ukraine relief funds,
													We will share the ledger of transactions with you to
													spread the word and cause and influence the community
													to join us for donations**
												</p>
											</div>
										</div>
										<div className="elementor-toggle-item">
											<div
												id="elementor-tab-title-1904"
												className="elementor-tab-title"
												data-tab={4}
												role="tab"
												aria-controls="elementor-tab-content-1904"
												aria-expanded="false">
												<span
													className="elementor-toggle-icon elementor-toggle-icon-right"
													aria-hidden="true">
													<span className="elementor-toggle-icon-closed">
														<i className="fas fa-plus" />
													</span>
													<span className="elementor-toggle-icon-opened">
														<i className="elementor-toggle-icon-opened fas fa-plus" />
													</span>
												</span>
												<a className="elementor-toggle-title">
													how many nfts can i mint?
												</a>
											</div>
											<div
												id="elementor-tab-content-1904"
												className="elementor-tab-content elementor-clearfix"
												data-tab={4}
												role="tabpanel"
												aria-labelledby="elementor-tab-title-1904">
												<p>
													Each Metamates ape holder will be able to mint upto 3
													unique metamates ape lounge characters
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
